import validator from "validator";
import { cloneDeep } from "lodash";

// Const
import { organizationType } from "const/nuclias/organization";
import {
  defaultSmsConfigState
} from "../../const";

const getDefaultSmsConfigState = (defaultSmsRoleState, accessLevel) => {
  const smsConfigState = cloneDeep(defaultSmsRoleState);

  smsConfigState.resendAfter.valid = true;
  smsConfigState.maximumResend.valid = true;
  smsConfigState.maximumRequest.valid = true;
  smsConfigState.denialPeriod.valid = true;
  smsConfigState.otpExpiresIn.valid = true;
  smsConfigState.allowedPhonePrefix.valid = true;
  smsConfigState.accessLevel.value = accessLevel;

  return smsConfigState;
}

const getSmsConfigState = (selectedSmsConfig, siteTagList, siteList, accessLevelType, accessLevel) => {
  const smsConfigState = getDefaultSmsConfigState(defaultSmsConfigState, accessLevel);

  if (!selectedSmsConfig) {
    return smsConfigState;
  }

  smsConfigState.name.value = selectedSmsConfig.rawData.name;
  smsConfigState.name.valid = true;

  smsConfigState.twilioAccountSid.value = selectedSmsConfig.rawData.twilioClientId;
  smsConfigState.twilioAccountSid.valid = true;

  smsConfigState.twilioAuthToken.value = selectedSmsConfig.rawData.twilioSecretId;
  smsConfigState.twilioAuthToken.valid = true;

  smsConfigState.twilioFromNumber.value = selectedSmsConfig.rawData.twilioFromNumber;
  smsConfigState.twilioFromNumber.valid = true;

  smsConfigState.resendAfter.value = selectedSmsConfig.rawData.smsResendAfter;
  smsConfigState.maximumResend.value = selectedSmsConfig.rawData.smsResendNumber;
  smsConfigState.maximumRequest.value = selectedSmsConfig.rawData.smsRequestNumber;
  smsConfigState.denialPeriod.value = selectedSmsConfig.rawData.smsDenialPeriod;
  smsConfigState.otpExpiresIn.value = selectedSmsConfig.rawData.smsExpiresIn;
  smsConfigState.allowedPhonePrefix.value = selectedSmsConfig.rawData.smsAllowedPhonePrefix.join(',');

  if (selectedSmsConfig.rawData.storeTagId) {
    smsConfigState.accessLevel.value = accessLevelType.tag;
    smsConfigState.siteTagOrSite.value = siteTagList.find(siteTag => siteTag.id === selectedSmsConfig.rawData.storeTagId);
  } else if (selectedSmsConfig.rawData.storeId) {
    smsConfigState.accessLevel.value = accessLevelType.site;
    smsConfigState.siteTagOrSite.value = siteList.find(site => site.id === selectedSmsConfig.rawData.storeId);
  } else {
    smsConfigState.accessLevel.value = accessLevelType.org;
  }

  return smsConfigState;
}

const changeName = (name, value) => {
  name.value = value;
  name.dirty = true;
  name.valid = name.required && validator.isByteLength(value, { min: name.minLength, max: name.maxLength });
}

const changeTwilioAccountSid = (twilioAccountSid, value) => {
  twilioAccountSid.value = value;
  twilioAccountSid.dirty = true;
  twilioAccountSid.valid = (!twilioAccountSid.required || validator.isByteLength(value, { min: twilioAccountSid.minLength, max: twilioAccountSid.maxLength })) ? true : false;
}

const changeTwilioAuthToken = (twilioAuthToken, value) => {
  twilioAuthToken.value = value;
  twilioAuthToken.dirty = true;
  twilioAuthToken.valid = (!twilioAuthToken.required || validator.isByteLength(value, { min: twilioAuthToken.minLength, max: twilioAuthToken.maxLength })) ? true : false;
}

const changeTwilioFromNumber = (twilioFromNumber, value) => {
  twilioFromNumber.value = value;
  twilioFromNumber.dirty = true;
  twilioFromNumber.valid = (!twilioFromNumber.required || twilioFromNumber.regex.test(value)) ? true : false;
}

const changeResendAfter = (resendAfter, value) => {
  resendAfter.value = value;
  resendAfter.dirty = true;
  resendAfter.valid = (!resendAfter.required || validator.isFloat(value, { min: resendAfter.min, max: resendAfter.max })) ? true : false;
}

const changeMaximumResend = (maximumResend, value) => {
  maximumResend.value = value;
  maximumResend.dirty = true;
  maximumResend.valid = (!maximumResend.required || validator.isFloat(value, { min: maximumResend.min, max: maximumResend.max })) ? true : false;
}

const changeMaximumRequest = (maximumRequest, value) => {
  maximumRequest.value = value;
  maximumRequest.dirty = true;
  maximumRequest.valid = (!maximumRequest.required || validator.isFloat(value, { min: maximumRequest.min, max: maximumRequest.max })) ? true : false;
}

const changeDenialPeriod = (denialPeriod, value) => {
  denialPeriod.value = value;
  denialPeriod.dirty = true;
  denialPeriod.valid = (!denialPeriod.required || validator.isFloat(value, { min: denialPeriod.min, max: denialPeriod.max })) ? true : false;
}

const changeOtpExpiresIn = (otpExpiresIn, value) => {
  otpExpiresIn.value = value;
  otpExpiresIn.dirty = true;
  otpExpiresIn.valid = (!otpExpiresIn.required || validator.isFloat(value, { min: otpExpiresIn.min, max: otpExpiresIn.max })) ? true : false;
}

const changeAllowedPhonePrefix = (allowedPhonePrefix, value) => {
  allowedPhonePrefix.value = value;
  allowedPhonePrefix.dirty = true;
  allowedPhonePrefix.valid = (!allowedPhonePrefix.required || allowedPhonePrefix.regex.test(value)) ? true : false;
}

const changeAccessLevel = (accessLevel, value) => {
  if (!value) {
    accessLevel.value = organizationType.org;
  } else {
    accessLevel.value = value.accessLevel;
  }
}

const changeSiteTagOrSite = (siteTagOrSite, value) => {
  siteTagOrSite.value = value;
}

export default {
  getSmsConfigState,
  changeName,
  changeTwilioAccountSid,
  changeTwilioAuthToken,
  changeTwilioFromNumber,
  changeResendAfter,
  changeMaximumResend,
  changeMaximumRequest,
  changeDenialPeriod,
  changeOtpExpiresIn,
  changeAllowedPhonePrefix,
  changeAccessLevel,
  changeSiteTagOrSite
};